var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"eLearningJunior container"},[_c('div',{staticClass:"eLearningJunior__cardContainer"},[_vm._l((_vm.juniorFilterLists),function(elementaryItem,index){return _c('ELearningImageCard',{key:index,attrs:{"item":elementaryItem,"type":'junior'}})}),_c('hr',{staticClass:"eLearningJunior__hr"})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }